const BriefingSoundType = {
    BRIEFING_CHAPTER_1: "briefing_chapter_1",
    BRIEFING_CHAPTER_2: "briefing_chapter_2",
    BRIEFING_CHAPTER_3: "briefing_chapter_3"
};

export default BriefingSoundType;